<template>
	<div class="basic_wrap">
		<div class="old_aipage" v-if="home_show == 1&& show_page">
			<div class="red_top_bg">
				<div class="big_tit">{{ $t('home.invest') }}</div>
			</div>
			<div class="item_wrap">
				<div class="tabs" v-show="show_tabs">
					<van-tabs type="card" v-model="active" @click="sort">
						<van-tab v-for="(tab, index) in tabs" :title="tab.title" :key="index"></van-tab>
					</van-tabs>
				</div>
				<div class="item_list">
					<van-list v-model="loading" loading-text=" " offset="0" :finished="finished"
						:finished-text="$t('utils.noData')" @load="onLoad">
						<div v-for="(item, index) in list" class="block_div item"
							@click="$router.push('/invest/detail/' + item.id)">
							<div class="logo">
								<img v-lazy="item.img" />
								<div>{{ item.title }}</div>
							</div>

							<div class="titledesc" style="color: red; font-size: 12px; margin-top: 10px; padding: 0 10px;">
								{{ item.titledesc }}</div>
							<div class="flex_center detail">
								<div>
									<div><span class="detail_name">{{ $t('index.amount') }}</span><span
											class="detail_num">{{ item.type2 == 1 ? common.currency_symbol_basic() : "" }}{{
												common.precision_basic(item.min) }}{{ item.type2 == 2 ? "TRX" : "" }}</span>
									</div>
									<div><span class="detail_name">{{ $t('index.cycle') }}</span><span class="detail_num">{{
										item.day }}{{ item.type == 3 ? $t('index.hour') : $t('index.day') }}</span>
									</div>
								</div>
								<div>
									<div><span class="detail_name">{{ item.type == 1 ? $t('index.dailyRate') :
										$t('index.rate') }}</span><span class="detail_num">{{ item.rate }}%</span></div>
									<div><span class="detail_name">{{ $t('invest.income') }}</span><span
											class="detail_num">{{ item.type2 == 1 ? common.currency_symbol_basic() : "" }}{{
												common.precision_basic(change(item)) }}{{ item.type2 == 2 ? "TRX" : "" }}</span>
									</div>
								</div>
							</div>
						</div>
					</van-list>
				</div>
			</div>
		</div>
		<div class="new_aipage" v-if="home_show == 0 && show_page">
			<!-- <div class="red_top_bg">
				<div class="big_tit">{{ $t('积分商城') }}</div>
			</div> -->
			<div class="red_top_bg_new" v-if="user.login">
			<!-- <div class="back_left" @click="$router.back()"></div> -->
			<div class="big_tit1" >{{ $t('goods.myPoint') }}{{ user.point }}</div>

		   <div class="right_box">
			<div class="point_record1" @click="$router.push('/integral/record')">
				{{ $t('积分明细') }}
			</div>

			<div class="record" @click="$router.push('/goods/record')">
				<img src="../img/user/record_b.png">
			</div>
		   </div>
		</div>
			<div class="swiper_container">
				<van-swipe :autoplay="2500" class="swiper-container">
					<van-swipe-item v-for="(item, index) in productList" :key="index"
						@click="$router.push('/goods/detail/' + item.id)" v-if="index < 3">
						<img :src="item.img">
					</van-swipe-item>
				</van-swipe>
			</div>
			<!-- 热门兑换 -->
			<div class="product_list_box">

				<!-- <div class="header_title">{{ $t('热门兑换') }}</div> -->
				<div class="product_list">
					<div class="item_product" v-for="(item, index) in productList" :key="index"
						@click="$router.push('/goods/detail/' + item.id)">
						<div class="pro_info">
							<img class="pro_logo" :src="item.img" alt="">
							<div class="detail_box">
								<div class="pro_title">{{ item.title }}<span class="hot_box">Hot</span></div>
								<div class="pro_point">{{ item.point }}{{ $t('goods.point') }}<span class="ydh">{{ $t('已兑换')
								}} {{ item.exchange_total }} {{ $t('次') }}</span></div>
							</div>
						</div>
						<!-- 兑换 -->
						<div class="duihuan_box">
							<div class="duihuan_btn">
								{{ $t('兑换') }}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue';
import bsHeader from '../../components/bsHeader.vue'
import Fetch from '../../utils/fetch'
import {
	Tab,
	Tabs,
	List,
	Empty,
	Lazyload,
	Swipe,
	SwipeItem,
} from 'vant';
Vue.use(Tab).use(Tabs).use(List).use(Empty).use(Lazyload);

Vue.use(Swipe).use(SwipeItem).use(List);
export default {
	name: "",
	components: {
		bsHeader
	},
	data() {
		return {
			data: [],
			show_tabs: false,
			tabs: [{
				id: 0,
				title: this.$t('tabs.all')
			}

			],
			active: 0,
			empty: false,
			loading: false,
			finished: false,
			list: [],
			page: 1,
			listRows: 8,
			productList: [],
			home_show: 0,
			user: {
				login: false,
				point: 0,
			},
			show_page:false

		};
	},
	// //创建前设置
	// beforeCreate() {
	// 	//解决List上拉加载bug
	// 	document.querySelector('body').style["overflow-y"] = "unset";
	// },
	// //销毁前清除
	// beforeDestroy() {
	// 	document.querySelector('body').style["overflow-y"] = "scroll";
	// },
	created() {
		if (window.plus) {
			plus.navigator.setStatusBarBackground('#FAFAFA');
			plus.navigator.setStatusBarStyle('dark');
		}
		this.$parent.footer('invest', true);
	},
	mounted() {
		if (this.$router.history.current.query.type) {
			this.active = parseInt(this.$router.history.current.query.type);
		}
		this.start();
	},
	methods: {
		change(item) {
			if (item.type == 1) {
				return this.common.precision_basic(item.min * item.rate * item.day / 100);
			} else {
				return this.common.precision_basic(item.min * item.rate / 100);
			}
		},
		start() {
			Fetch('/index/item_class').then((r) => {
				var tabs1 = [{
					id: 0,
					title: this.$t('tabs.all')
				}];
				r.data.classes.forEach(item => {
					tabs1.push({
						id: item.id,
						title: item.title,
					})
				})
				this.tabs = tabs1;
				this.show_tabs = true;
			});

			Fetch('/index/goods_list', {
				page: 1,
				listRows: 10000
			}).then(r => {
				this.user = r.data.user;
				var productList = r.data.list;
				for (var i = 0; i < productList.length; i++) {
					this.productList.push(productList[i]);
				}

			});

			Fetch('/index/int').then((r) => {
				this.home_show = r.data.home_show;
				this.show_page=true;
			});
		},
		sort(index) {
			this.page = 1;
			this.empty = false;
			this.list = [];
			this.finished = false;
			this.loading = true;
			this.onLoad();
		},
		onLoad() {
			Fetch('/index/item_list', {
				page: this.page,
				listRows: this.listRows,
				type: this.tabs[this.active]['id']
			}).then(r => {
				if (r.data.length == 0) this.empty = true;
				var list = r.data.list;
				for (var i = 0; i < list.length; i++) {
					this.list.push(list[i]);
				}
				if (this.list.length >= r.data.length) {
					this.finished = true;
					return;
				}
				this.page = this.page + 1;
				this.loading = false;
			});
		}
	}
};
</script>

<style lang="less" scoped>
.basic_wrap {
	position: relative;
	margin-bottom: 100px;
	max-width: 750px;
	background-color: white;
}

.swiper_container {
	// min-height: 182px;
	position: relative;
	background: #FFFFFF;
}

.swiper-container {
	width: 100%;
	margin: 54px 0 0 0;


	.van-swipe-item {
		overflow: hidden;
	}

	img {
		border-radius: 5px;
		margin-left: 3%;
		height: 100%;
		width: 94%;
	}
}

.product_list_box {
	padding: 20px 16px;
	background-color: #FFFFFF;
	box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.05);
	display: flex;
	flex-direction: column;

	.header_title {
		font-size: 15px;
		color: black;
		font-weight: 600;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 15px;
	}

	.product_list {
		.item_product {
			display: flex;
			justify-content: space-between;
			padding: 20px 0;
			border-bottom: 1px solid rgba(185, 174, 174, 0.3);

			.pro_info {
				display: flex;
				justify-content: left;



				.pro_logo {
					width: 80px;
					height: 80px;
				}

				.detail_box {
					display: flex;
					flex-direction: column;
					margin-left: 10px;
					flex: 1;

					.pro_title {
						font-size: 14px;
						line-height: 20px;
						color: black;
						font-weight: 500;

						.hot_box {
							padding: 1px 6px;
							border: 1px solid red;
							border-radius: 25px;
							font-size: 10px;
							color: red;
							margin-left: 5px;

						}
					}

					.pro_point {
						font-size: 14px;
						color: #FFA500;
						font-weight: 500;
						margin-top: auto;

						.ydh {
							font-size: 12px;
							margin-left: 5px;
							color: #817d78;
						}
					}


				}
			}

			.duihuan_box {
				min-width: 120px;
				display: flex;
				align-items: center;
				justify-content: right;

				.duihuan_btn {
					padding: 5px 16px;
					border-radius: 50px;
					display: flex;
					align-items: center;
					justify-content: center;
					background: rgba(173, 216, 230, 0.5);
					color: #0F6EFF;
					font-size: 13px;
					display: inline-block;
				}

			}
		}
	}
}

.red_top_bg_new {
	// position: fixed;
	display: flex;
	align-items: center;
	justify-content: space-between;
	background: #FFFFFF;
	z-index: 10;
	height: 50px;
	position: fixed;
	width: 100%;
	top: 0;
	padding: 0 16px;
	.big_tit1{
		font-size: 16px;
	}
	.right_box{
		display: flex;
		align-items: center;
		justify-content: right;
		.point_record1{
			font-size: 14px;
			margin-right: 5px;
		}
	}


	.point_record {
		// position: absolute;
		// top: 13px;
		// right: 55px;
		font-size: 14px;
	}

	.record {
		// position: absolute;
		// top: 11px;
		// right: 15px;

		img {
			width: 22px;
			height: 22px;
		}
	}
}

.red_top_bg {
	position: fixed;
	top: 0;
	z-index: 10;
	box-shadow: unset;
	background: #FFF;

	.big_tit {
		left: 50%;
		transform: translateX(-50%);
	}
}

.item_wrap {
	width: 100%;
	margin-top: 44px;

	.tabs {
		position: fixed;
		z-index: 100;
		width: 100%;
		background: #FAFAFA;
	}

	.item_list {
		position: relative;
		top: 45px;
		margin-bottom: 20px;

		.item {
			margin-bottom: 10px;


			.logo {
				position: relative;

				div {
					position: absolute;
					bottom: 0px;
					width: 100%;
					background: #FFFFFF;
					height: 30px;
					line-height: 30px;
					opacity: 0.8;
					font-weight: bold;
					padding: 0 10px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}

				img {
					width: 100%;
					border-radius: 5px;
					max-height: 260px;
				}
			}

			.detail {
				padding: 15px;
				line-height: 2;

				.detail_name {}

				.detail_num {
					font-weight: bold;
					color: #3CB371;
				}
			}
		}

	}
}

/deep/.van-tabs__nav--card {
	margin: 0 2%;
}

/deep/.van-tabs {
	margin-bottom: 10px;
}

/deep/.van-tabs__nav--card .van-tab {
	border-right: unset;
	background: #FFFFFF;
	margin-right: 10px;
	border-radius: 15px;
}

/deep/.van-tabs__nav--card {
	border: unset;
}

/deep/.van-tabs__nav {
	background: unset;
}

/deep/.van-tabs__nav--card .van-tab.van-tab--active {
	background: #0F6EFF;
}</style>
